import * as React from "react";
function SvgHspRetweet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#5a5a5a"
        d="M2.5 6.3v2.5H0V5c0-.8.5-1.3 1.3-1.3h14.5l-1.6-1.6c-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0l3.8 3.8c.5.5.5 1.3 0 1.8L16 9.7c-.4.2-.6.3-1 .3s-.6-.1-.9-.4c-.5-.5-.5-1.3 0-1.8l1.6-1.6H2.5zm15 7.5v-2.5H20V15c0 .8-.5 1.3-1.3 1.3H4.3l1.6 1.6c.5.5.5 1.3 0 1.8-.3.2-.5.3-.9.3s-.6-.1-.9-.4L.3 15.8c-.5-.5-.5-1.3 0-1.8l3.8-3.8c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8l-1.6 1.6h13.2z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHspRetweet);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
